import React from 'react';
import YouTube from 'react-youtube';
import ModalVideo from 'react-modal-video'

export default function YouVideoPreview(props) {

  const { isMobile } = props;

  const handleClose = () => {
    props.onClose();
  };

  return (
    <ModalVideo channel='youtube' autoplay isOpen={props.isOpen} videoId={props.videoId} onClose={() => handleClose()} />
  );
}



// WEBPACK FOOTER //
// ./src/components/YouVideoPreview.js